/* eslint-disable @typescript-eslint/no-explicit-any */

export function getLastIndex(array: any[]): number {
  const lastIndex = array.length - 1;

  return lastIndex;
}

export function getLast<E = any>(array: E[]): E | undefined {
  const lastIndex = getLastIndex(array);

  return array[lastIndex];
}

export function getFirst<E = any>(array: E[]): E {
  return array[0];
}

export function getNextIndex(index: number): number {
  return index + 1;
}

// eg the 1st item is index 0
export function getNth<E = any>(list: E[], itemNumber: number): E | undefined {
  const nthIndex = itemNumber - 1;

  return list[nthIndex];
}

/**
 * A special wrapper to fill a whole the default `array.indexOf()` method has,
 * which returns `-1` if the index is not found
 *
 * With this you can leverage nullish checks like indexOrNull(list, x) ?? default
 * without the mental work of remembering the special -1 case
 */
export function indexOfOrNull(list: any[], itemToFindIndex: any): number | null {
  const index = list.indexOf(itemToFindIndex);

  return index >= 0 ? index : null;
}
